import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import {FALLBACKLNG, AVAILABLELANGUAGES} from './constants'

const fallbackLng = FALLBACKLNG;
const availableLanguages = AVAILABLELANGUAGES.map((item=>item.id));

let localesMap = {};

let validLocalesCodesMap = {};

const resources = (function(arg){

    let resources = {};
    localesMap = {};
    validLocalesCodesMap = {};

    arg.lc.forEach( locale => {

        localesMap[locale.id] = locale;

        validLocalesCodesMap[locale.locale] = true;
        validLocalesCodesMap[locale.id] = true;

        let forImport = '';
        switch (locale.id) {
            case ('zh_cn') :
                forImport = 'zh-cn';
                break;
            case ('zh_tw') :
                forImport = 'zh-tw';
                break;
            case ('ko_kr') :
                forImport = 'ko';
                break;
            case ('en') :
                forImport = 'en-gb';
                break;
            default :
                forImport = locale.id;
                break;
        }
        return import (`moment/locale/${forImport}`);
    });

    validLocalesCodesMap['en-US']=true;

    //availableLanguages = arg.lc.map((item=>item.id));

    for(let locale in arg.tr) {

        resources[locale] = {}
        resources[locale]["translation"] = {}

        /*if (locale !=='en') {
            for (let trans of arg.tr[locale]) {
                resources[locale]["translation"][trans.id] = trans.translation
            }
        } else {*/
        if (Array.isArray(arg.tr[locale])) {
            for (let trans of arg.tr[locale]) {
                resources[locale]["translation"][trans.id] = (trans.translation !== "") ? trans.translation : trans.id
            }
        }
        /*}*/

        resources[locale]["translation"].currentFull = localesMap[locale].name;
        resources[locale]["translation"].currentShort = localesMap[locale].id;
    }
    return resources
})( {tr : window.Bagbnb && window.Bagbnb.translations || [], lc: window.Bagbnb && window.Bagbnb.locales || []})

const customDetectPath = {
    name: 'customDetectPath',
    type: 'languageDetector',

    lookup(options) {
        let found;
        if (typeof window !== 'undefined') {
            const language = window.location.pathname.match(/\/([a-zA-Z-_]*)/g);
            if (language instanceof Array) {
                if (typeof options.lookupFromPathIndex === 'number') {
                    if (typeof language[options.lookupFromPathIndex] !== 'string') {
                        return undefined;
                    }
                    found = language[options.lookupFromPathIndex].replace('/', '');
                } else {
                    found = language[0].replace('/', '');
                }
            }
        }
        return found;
    }
};

const languageDetector = new LanguageDetector();
languageDetector.addDetector(customDetectPath);
i18n
    .use(languageDetector) // detect user language

    .use(initReactI18next) // pass the i18n instance to react-i18next.

    .init({
        resources,
        fallbackLng, // if user computer language is not on the list of available languages, than we will be using the fallback language specified earlier
        //debug: true,
        whitelist: availableLanguages,
        keySeparator: false,
        nsSeparator:false,
        detection:{
            order: ['customDetectPath', 'path', 'querystring', 'subdomain', 'cookie'],
            caches: [],
            lookupFromPathIndex: 0
        },
        interpolation: {
            escapeValue: false
        },
        react:{
            wait: true
        },
    });

export default i18n;

const navigatorLang = window.navigator.language || window.navigator.userLanguage;
export const userLang = validLocalesCodesMap[navigatorLang] ? navigatorLang : 'en-GB';

console.log('i18n',i18n);
